export default __webpack_public_path__ + "static/media/livelife-logo.ec4789fe.jpg";